import Layout from './layout'

export default [
  {
    path: '/pid-manage',
    component: Layout,
    meta: { groupTitle: '通用', roles: ['taoke'] },
    children: [
      {
        path: '',
        name: 'PIDManage',
        badge: 'authRemain7day',
        component: () => import(/* webpackChunkName: "pidManage" */ '@v/pidManage'),
        meta: { title: '联盟设置', icon: 'pid' },
      },
    ],
  },
  // {
  //   path: '/pid-manage-authpage',
  //   name: 'PIDManageAuthpage',
  //   hidden: true,
  //   component: () => import(/* webpackChunkName: "authpage" */ '@v/pidManage/authpage')
  // },
]